var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampingplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.128,8.638H13.043A5.8,5.8,0,0,0,7.356,3.943H3.105a1.1,1.1,0,0,0-1.1,1.1v4.7a1.1,1.1,0,0,0,1.1,1.1H4.794a1.376,1.376,0,0,0,2.512,0h4.748a1.1,1.1,0,0,0,1.1-1.1c0-.13-.011-.257-.019-.385h1a.358.358,0,0,0,0-.715Zm-8.078,2.3a.667.667,0,1,1,.667-.666A.667.667,0,0,1,6.05,10.933Zm6-.813H10.36a.609.609,0,0,0,.041-.2V6.862a.628.628,0,0,0-.628-.628H8.89a.628.628,0,0,0-.628.628V9.92a.635.635,0,0,0,.04.2H7.416a1.374,1.374,0,0,0-2.733,0H3.105a.382.382,0,0,1-.381-.382v-4.7a.382.382,0,0,1,.381-.382H7.356a5.086,5.086,0,0,1,5.08,5.081A.382.382,0,0,1,12.054,10.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.779,
    y: 5.86,
    width: 2.903,
    height: 1.528,
    rx: 0.5,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampingplads);
export default __webpack_public_path__ + "static/media/CAMPINGPLADS.24a6f18b13cafd8969639e5789f8a920.svg";
export { ForwardRef as ReactComponent };